// Must stay the first import: sets the global `Phaser` that game systems use.
import '@game/utils/phaser-global';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { GameManagerProvider } from './contexts/GameManagerContext';
import './index.css';

// Initialize React overlay
const rootElement = document.getElementById('react-root');

if (!rootElement) {
  console.error('React root element not found');
} else {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <GameManagerProvider>
        <App />
      </GameManagerProvider>
    </React.StrictMode>
  );
}